export default __webpack_public_path__ + "media/zurb/img/about/bryan/bryan-img1-da1190a257c8a8eacad6510322a56b7d.png";